import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1958ae84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "imgText" }

import { watch, ref, unref, onMounted, onBeforeUnmount } from 'vue';
import { TxtContent } from '../type';
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import { init, apikey } from '@/components/CTinymce';
import { Alert } from 'ant-design-vue';
interface IProps {
  modelValue: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageText',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: any;
};

const aAlert = Alert;


const form = ref<TxtContent>({
  content: '',
});
form.value = unref(props.modelValue);

watch(form.value, (newVal) => {
  emit('update:modelValue', newVal);
});

onMounted(() => {
  tinymce.init({});
});
onBeforeUnmount(() => {
  tinymce.remove();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_unref(aAlert), {
        type: "warning",
        class: "cache_tips",
        message: "图片需要自适应时，需要设置图片宽度为：100%，高度可以留空。",
        banner: "",
        closable: ""
      }),
      _createVNode(_unref(Editor), {
        modelValue: form.value.content,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.content) = $event)),
        "api-key": _unref(apikey),
        init: _unref(init)
      }, null, 8, ["modelValue", "api-key", "init"])
    ])
  ]))
}
}

})